<template>
    <modal :show="true" body-classes="p-0" modal-classes="modal-dialog-centered modal-sm">
        <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-4 py-lg-5"
            class="border-0"
            style="margin-bottom: 0"
        >
            <template v-if="true">
                <div class="text-muted text-center mb-4">
                    <span>{{ $t('leads.access_content') }}</span>
                </div>
                <div class="text-center mb-3">
                    <small class="text-muted">{{ $t('leads.fill_form_access') }}</small>
                </div>
            </template>
            <template v-if="true">
                <form id="lead-capture-form" role="form" class="mt-4">
                    <base-input
                        v-model="form.name"
                        :name="$t('leads.name')"
                        class="mb-3"
                        :placeholder="$t('leads.name_placeholder')"
                        prepend-icon="ni ni-circle-08"
                        :error="errors.name"
                    ></base-input>

                    <base-input
                        v-model="form.email"
                        :name="$t('leads.email')"
                        type="email"
                        class="mb-3"
                        :placeholder="$t('leads.email_placeholder')"
                        prepend-icon="ni ni-email-83"
                        :error="errors.email"
                    ></base-input>

                    <base-input
                        v-model="form.phone"
                        :name="$t('leads.phone')"
                        type="tel"
                        class="mb-3"
                        :placeholder="$t('leads.phone_placeholder')"
                        prepend-icon="ni ni-mobile-button"
                        :error="errors.phone"
                    ></base-input>

                    <div class="text-center">
                        <base-button
                            @click.stop="submitLead"
                            :loading="isSubmitting"
                            :style="$bgColor(color.primary)"
                            class="my-4 tw-text-white"
                        >{{ $t('leads.access_content_btn') }}</base-button>
                    </div>
                </form>

                <div class="text-center mt-3">
                    <small class="text-muted d-flex align-items-center justify-content-center">
                        <i class="fas fa-shield-alt text-success mr-2"></i>
                        {{ $t('leads.privacy_notice') }}
                    </small>
                </div>
            </template>
        </card>
    </modal>
</template>

<script>
import Card from '../../argon/components/Cards/Card';
import Modal from '../../argon/components/Modal';
import BaseButton from '../../argon/components/BaseButton';
import BaseInput from '../../argon/components/Inputs/BaseInput';

export default {
    name: 'PlansLeadCapture',

    components: {
        Card,
        Modal,
        BaseButton,
        BaseInput,
    },

    props: {
        planId: {
            type: [String, Number],
            required: true,
        },
    },

    data() {
        return {
            form: {
                name: '',
                email: '',
                phone: '',
            },
            errors: {},
            isSubmitting: false,
        };
    },

    computed: {
        color() {
            return this.$store.getters.COLOR;
        },
    },

    methods: {
        validateForm() {
            this.errors = {};

            // Validação mais permissiva - apenas verifica se pelo menos um campo foi preenchido
            const hasName = this.form.name && this.form.name.trim().length >= 2;
            const hasEmail = this.form.email && this.isValidEmail(this.form.email);
            const hasPhone = this.form.phone && this.form.phone.trim().length >= 8;

            if (!hasName && !hasEmail && !hasPhone) {
                this.errors.name = this.$t('leads.errors.at_least_one_field_required');
                return false;
            }

            // Validação do nome se preenchido
            if (this.form.name &&
                this.form.name.trim().length > 0 &&
                this.form.name.trim().length < 2) {
                this.errors.name = this.$t('leads.errors.name_min_length');
            }

            // Validação do email se preenchido
            if (this.form.email &&
                this.form.email.trim().length > 0 &&
                !this.isValidEmail(this.form.email)) {
                this.errors.email = this.$t('leads.errors.email_invalid');
            }

            // Validação do telefone se preenchido
            if (this.form.phone &&
                this.form.phone.trim().length > 0 &&
                !this.isValidPhone(this.form.phone)) {
                this.errors.phone = this.$t('leads.errors.phone_invalid');
            }

            return Object.keys(this.errors).length === 0;
        },

        isValidEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },

        isValidPhone(phone) {
            const phoneRegex = /^[+]?[1-9][\d]{0,15}$/;
            return phoneRegex.test(phone.replace(/[\s\-()]/g, ''));
        },

        async submitLead() {
            console.log('=== SUBMIT LEAD DEBUG ===');
            console.log('Form data:', this.form);
            console.log('Plan ID:', this.planId);

            if (!this.validateForm()) {
                console.log('Validation failed:', this.errors);
                return;
            }

            console.log('Validation passed, submitting...');
            this.isSubmitting = true;

            try {
                console.log('Making API request to /api/leads/capture');
                const response = await window.axios.post('/api/leads/capture', {
                    ...this.form,
                    plan_id: this.planId,
                });

                console.log('API Response:', response.data);

                if (response.data.success) {
                    console.log('Success! Redirecting...');

                    this.$notify({
                        type: 'success',
                        message: response.data.message || this.$t('leads.success.captured'),
                    });

                    // Redireciona para o conteúdo do plano
                    this.$loading.show();

                    // Obtém a URL assinada para o plano público
                    window.axios.get(`/api/app/public/plan/${this.planId}/signed-url`)
                        .then((urlResponse) => {
                            if (urlResponse.data && urlResponse.data.url) {
                                console.log('Redirecting to signed URL:', urlResponse.data.url);
                                window.location.href = urlResponse.data.url;
                            } else {
                                console.error('No signed URL returned');
                                window.location.href = `/app/public/plan/${this.planId}`;
                            }
                        })
                        .catch((error) => {
                            console.error('Error getting signed URL:', error);
                            window.location.href = `/app/public/plan/${this.planId}`;
                        });
                } else {
                    console.log('API returned success=false:', response.data);
                    this.handleError(response.data.message || this.$t('leads.errors.submission_failed'));
                }
            } catch (error) {
                console.error('=== API ERROR ===');
                console.error('Full error:', error);
                console.error('Response data:', error.response?.data);
                console.error('Status:', error.response?.status);

                if (error.response && error.response.data && error.response.data.errors) {
                    console.log('Setting validation errors:', error.response.data.errors);
                    this.errors = error.response.data.errors;
                } else {
                    this.handleError(error.response?.data?.message || this.$t('leads.errors.submission_failed'));
                }
            } finally {
                this.isSubmitting = false;
                console.log('=== SUBMIT LEAD END ===');
            }
        },

        handleError(message) {
            this.$notify({
                type: 'danger',
                message,
            });
        },
    },
};
</script>

<style scoped>
/* Estilos customizados se necessário */
</style>
